module.exports = __webpack_public_path__ + "assets/amazon-web-services.f8722a08.svg";